import { render, staticRenderFns } from "./UserDetailStatisticTileItem.vue?vue&type=template&id=8de6339a&scoped=true&lang=pug&"
import script from "./UserDetailStatisticTileItem.vue?vue&type=script&lang=js&"
export * from "./UserDetailStatisticTileItem.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailStatisticTileItem.vue?vue&type=style&index=0&id=8de6339a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de6339a",
  null
  
)

export default component.exports